export const ActionsEnum = {
  phone: {
    key: 'phone', // must be unique
    icon: 'mdi mdi-phone',
    buttonClasses: 'btns-icon theme-action bg-secondary',
  },
  call: {
    key: 'call', // must be unique
    icon: 'mdi mdi-phone',
    buttonClasses: 'btns-icon theme-action bg-secondary',
  },
  email: {
    key: 'email',
    icon: 'icons i-email',
    buttonClasses: 'btns-icon theme-action bg-warning',
  },
  sms: {
    key: 'sms',
    icon: 'mdi mdi-cellphone',
    buttonClasses: 'btns-icon theme-action bg-secondary',
  },
  whatsapp: {
    key: 'whatsapp',
    icon: 'mdi mdi-whatsapp',
    buttonClasses: 'btns-icon theme-action bg-green-dark',
  },
  account: {
    key: 'account',
    icon: 'icons i-account',
    buttonClasses: 'btns-icon theme-action bg-primary',
  },
  dotsHorizontal: {
    key: 'dotsHorizontal',
    icon: 'mdi mdi-dots-horizontal',
    buttonClasses: 'btns-icon theme-action bg-primary',
  },
  add: {
    key: 'add', // must be unique
    icon: 'mdi mdi-plus',
    buttonClasses: 'btns-icon theme-solid bg-green',
  },
  edit: {
    key: 'edit',
    icon: 'mdi mdi-lead-pencil',
    buttonClasses: 'btns-icon theme-solid bg-secondary',
  },
  delete: {
    key: 'delete',
    icon: 'mdi mdi-trash-can',
    buttonClasses: 'btns-icon theme-solid bg-danger',
  },
  check: {
    key: 'check',
    icon: 'mdi mdi-check',
    buttonClasses: 'btns-icon theme-solid bg-green',
  },
  close: {
    key: 'close',
    icon: 'mdi mdi-close',
    buttonClasses: 'btns-icon theme-solid bg-secondary',
  },
  activate: {
    key: 'Activate',
    icon: 'mdi mdi-check',
    buttonClasses: 'btns-icon theme-solid bg-green',
  },
  deactivate: {
    key: 'Deactivate',
    icon: 'mdi mdi-close',
    buttonClasses: 'btns-icon theme-solid bg-secondary',
  },
  reportView: {
    key: 'reportView',
    icon: 'icons i-report-view-white',
    buttonClasses: 'btns-icon theme-solid',
  },
  reportEdit: {
    key: 'reportEdit',
    icon: 'icons i-report-edit-white',
    buttonClasses: 'btns-icon theme-solid',
  },
  folder: {
    key: 'folder',
    icon: 'icons i-folder-white',
    buttonClasses: 'btns-icon theme-solid',
  },
  preview: {
    key: 'preview',
    icon: 'mdi mdi-eye-outline',
    buttonClasses: 'btns-icon theme-solid',
  },
  matching: {
    key: 'matching',
    icon: 'mdi mdi-link-box-outline',
    buttonClasses: 'btns-icon theme-solid',
    label: 'matching',
  },
  phoneSolid: {
    key: 'phoneSolid', // must be unique
    icon: 'mdi mdi-phone',
    buttonClasses: 'btns-icon theme-solid',
  },
  smsSolid: {
    key: 'smsSolid',
    icon: 'mdi mdi-cellphone',
    buttonClasses: 'btns-icon theme-solid',
  },
  emailSolid: {
    key: 'emailSolid', // must be unique
    icon: 'mdi mdi-email-outline',
    buttonClasses: 'btns-icon theme-solid',
  },
  whatsappSolid: {
    key: 'whatsappSolid', // must be unique
    icon: 'mdi mdi-whatsapp',
    buttonClasses: 'btns-icon theme-solid bg-green-dark',
  },
  reassignAgent: {
    key: 'reassignAgent', // must be unique
    icon: 'mdi mdi-account-switch',
    buttonClasses: 'btns-icon theme-solid',
  },
  SendListingSend: {
    key: 'SendListingSend', 
    icon: 'mdi mdi-file-send',
    buttonClasses: 'btns-icon theme-solid',
    label: 'Send to Listing Agent',
  },
};
